import {
  GET_LOGIN_USER_FAIL, GET_LOGIN_USER_SUCCESS, GET_LOGIN_USER_REQUEST
  } from "../constant";

  const initialState = {
    userData: [],
    userFlag: false
  };

  const loginUserReducer = (state = initialState, action) => {
    switch (action.type) {
      //Get user data
      case GET_LOGIN_USER_REQUEST:
        return {
          ...state,
          userData: [],
          userFlag: false
        };
      case GET_LOGIN_USER_SUCCESS:
        //console.log("action.payload?.data1",action.payload?.data)
        return {
          ...state,
          userData: action.payload?.data,
          userFlag: true
        };
      case GET_LOGIN_USER_FAIL:
        return {
          ...state,
          userData: [],
          userFlag: false
        };

      default:
        return state;
    }
  };

  export { loginUserReducer };

